"use client";

import { Box } from "@chakra-ui/react";
import { UploadScreen } from "./components/UploadScreen";
import { AnalysisLoading } from "./components/AnalysisLoading";
import { ResultScreen } from "./components/ResultScreen";
import { ErrorScreen } from "./components/ErrorScreen";
import {
  BenchmarkProvider,
  BenchmarkStage,
  useBenchmarkContext,
} from "./_context/BenchmarkContext";

function ResumeAnalysisPageContent() {
  const { stage, startBenchmark, reset, isStarting, benchmarkDetails } =
    useBenchmarkContext();

  const renderStage = () => {
    if (stage === BenchmarkStage.UPLOAD)
      return <UploadScreen onAnalyze={startBenchmark} isLoading={isStarting} />;
    if (stage === BenchmarkStage.LOADING) return <AnalysisLoading />;
    if (stage === BenchmarkStage.RESULT) {
      // Re-fetching details after remount (e.g. language switch)
      if (!benchmarkDetails) return <AnalysisLoading />;
      return <ResultScreen onReset={reset} />;
    }
    if (stage === BenchmarkStage.ERROR) return <ErrorScreen onReset={reset} />;
    return null;
  };

  return <Box>{renderStage()}</Box>;
}

export function ResumeBenchmarkClient() {
  return (
    <BenchmarkProvider>
      <ResumeAnalysisPageContent />
    </BenchmarkProvider>
  );
}
